const formatPrice = (...prices: (string | number)[]): string => {
  const totalPrice = prices.reduce((a, b) => {
    const num1: number = +a;
    const num2: number = +b;
    return num1 + num2;
  }, 0);
  return totalPrice.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export default formatPrice;
